import React, { useState,useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import { unescapeHtml,LoginAfterCheckLogin } from "../../components/common/Common";

import "../../css/style.css";

//결제관리
const Condition = () => {
  LoginAfterCheckLogin(2);  //로그인 상태 점검\
  const { terms } = useParams();

  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varConditionInfo,setConditionInfo] = useState({});

  //결제 정보 목록
  const GetConditionInformation = async() => {
    const sendData = {terms:terms};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_condition`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const newTerms = {title:datas.title,comment:datas.comment}
        setConditionInfo(newTerms);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});

    GetConditionInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="vh-content oper-wrap">
      <HeaderBranchTitle varPageTitle={varConditionInfo.title} varBackString={'/Branch/Operating'}/>
      <div className="vh-content-body mt25">
				<div className="center-wrap" style={{whiteSpace:"pre-line"}}>{unescapeHtml(varConditionInfo.comment)}</div>
      </div>
    </div>	
  );
}
export default Condition;